import { Url } from '@/constants';
import BaseApi from './base';

const getFooterOptions = () => BaseApi.get(`${Url.localBaseUrl}/data/footer.json`, {});

export { getFooterOptions };
